import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { DataItem } from '../dataqueries/dataQuery.types';
import { DisplayListResult } from './DisplayListResult';
import { DisplayResult } from './DisplayResult';
import { Column, formatColumnHuman, getColumnValue, getTableColumns } from './tableData';

type ResultTableProps = {
    items: DataItem[];
    hasMore: boolean;
};

type ResultColumnProps = {
    columns: Column[];
};

export const ResultTable: FunctionComponent<ResultTableProps> = ({ items, hasMore }) => {
    const columns = getTableColumns(items);
    return (
        <>
            <table className="table table-layout-auto table-column-overflow-hidden table-hover table-head-filled rounded border">
                <ResultTableColumns columns={columns} />
                <thead>
                    <ResultTableHeader columns={columns} />
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <ResultTableRow key={index} columns={columns} item={item} />
                    ))}
                </tbody>
            </table>
            {hasMore && <HasMore />}
        </>
    );
};

const ResultTableColumns: FunctionComponent<ResultColumnProps> = ({ columns }) => (
    <colgroup>
        {columns.map((column) => (
            <col key={column.toString()} className="min-width-100" />
        ))}
    </colgroup>
);

const ResultTableHeader: FunctionComponent<ResultColumnProps> = ({ columns }) => (
    <tr>
        {columns.map((column) => (
            <th key={column.toString()}>{formatColumnHuman(column)}</th>
        ))}
    </tr>
);

const ResultTableRow: FunctionComponent<ResultColumnProps & { item: DataItem }> = ({ columns, item }) => (
    <tr>
        {columns.map((column) => {
            const value = getColumnValue(column, item);
            const isList = Array.isArray(value);
            return (
                <td key={column.toString()}>
                    {isList ? <DisplayListResult values={value} /> : <DisplayResult value={value} />}
                </td>
            );
        })}
    </tr>
);

const HasMore: FunctionComponent = () => {
    return (
        <div className="align-items-center display-flex justify-content-center margin-top-25 margin-bottom-25 non-printable">
            <div className="min-width-150">
                <div className="display-flex justify-content-center">
                    <span className="padding-top-4 padding-bottom-10">
                        <FormattedMessage id="outboundOrderBook.inspector.dataquery.hasMoreData" />
                    </span>
                </div>
            </div>
        </div>
    );
};
